import {BodyStat} from './BodyStat';

export class PatientRegistration {
  email: string;
  name: string;
  surname: string;
  ssn: string;
  birthDate: string;
  // birthPlace: string;
  // phoneNumber: string;
  doctorID: string;
  pathology: string;

  // tslint:disable-next-line:max-line-length
  constructor(email: string, name: string, surname: string, ssn: string, birthDate: string, /*birthPlace: string phoneNumber: string, */ doctorID: string,pathology: string) {
    this.email = email;
    this.name = name;
    this.surname = surname;
    this.ssn = ssn;
    this.birthDate = birthDate;
    // this.birthPlace = birthPlace;
    // this.phoneNumber = phoneNumber;
    this.doctorID = doctorID;
    this.pathology = pathology;
  }
}
